﻿import * as types from './mutation-types';
import * as mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters'


const state = {
    alertModal : {
        show : false,
        header : '',
        body : '',
        footer : ''
    },
    customer: {
        existingCustomer: false,
        badPayer: false,
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        fixedPhone: '',
        street: '',
        houseNumber: '',
        houseLetter: '',
        floor: '',
        door: '',
        zipCode: '',
        city: '',
        cprNumber: '',
        email: '',
        emailConfirmed: '',
        billingAddress: {}
    },
    basket : { id : 0, content : {} },
    form: [],
    existingCustomerBlockActive: false,
    customerDataValidated: false,
}

export default{
    state,
    getters,
    mutations,
    actions
}